import React from 'react'
import storageWalkLogo from "../../logo/white_storage_walk_logo.png"
import { usePublicSiteBranding } from '../../contexts/PublicSiteContext'

const About = ({about}: any) => {
  const branding = usePublicSiteBranding()
  const aboutLogo = branding.heroMarkLogoSrc ?? branding.markLogoSrc ?? storageWalkLogo
  return (
    <div ref={about} className="w-full mx-auto py-20 px-6 bg-marketing-surface">
      <div className="flex flex-col items-center">
          <div className="flex w-3/4 flex-col text-3xl md:text-4xl tracking-wide text-white font-bold">
              About
          </div>
          <p className="text-sm w-3/4 mt-6 text-white leading-6 whitespace-pre-line">
          {branding.aboutParagraph}
          </p>
          <div className="flex justify-start w-3/4 items-start mt-8">
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <img src={aboutLogo} alt={branding.aboutLogoAlt} className="w-40 md:w-48 h-auto object-contain" />
            </div>
          </div>
      </div>
    </div>
  )
}

export default About